import * as actions from "../action.constants";

const requestOrganizations = (pageUrl) => ({
  type: actions.REQUEST_ORGANIZATIONS,
  pageUrl,
});

const createOrganization = (requestPayload, callback) => ({
  type: actions.CREATE_ORGANIZATION,
  requestPayload,
  callback,
});

const syncTemplates = (payload) => ({
  type: actions.SYNC_TEMPLATES,
  payload,
});

const requestOrganization = (payload) => ({
  type: actions.REQUEST_ORGANIZATION,
  payload,
});

const storeOrganizations = (responsePayload) => ({
  type: actions.SAVE_ORGANIZATIONS_LIST,
  responsePayload,
});

const storeOrganization = (payload) => ({
  type: actions.STORE_ORGANIZATION,
  payload,
});

const requestOrganizationApps = (payload) => ({
  type: actions.REQUEST_ORGANIZATIONS_APPS,
  payload,
});

const storeOrganizationApps = (payload) => ({
  type: actions.STORE_ORGANIZATIONS_APPS,
  payload,
});

export {
  requestOrganizations,
  createOrganization,
  syncTemplates,
  requestOrganization,
  storeOrganization,
  requestOrganizationApps,
  storeOrganizationApps,
  storeOrganizations,
};
